import React, {useMemo} from 'react';
import withStore from "@/hocs/withStore";
import CardAll from "@/Pages/All/CardAll";
import CardAllEmpty from "@/Pages/All/CardAllEmpty";

const CatalogList = ({...props}) => {
    const {stores = {}} = props;
    const {filterStore = {}} = stores;

    const catalogFilterData = useMemo(() => {
        if (filterStore.catalogFilterResult.length === 0) {
            return <>
                <CardAllEmpty />
                <CardAllEmpty />
                <CardAllEmpty />
                <CardAllEmpty />
                <CardAllEmpty />
            </>
        }
        return filterStore.catalogFilterResult.map((el, i) => {
            return <CardAll key={el.id} el={el} {...props} index={i} type={`catalog`} />
        });
    }, [filterStore.catalogFilterResult]);

    return <>
        {
            filterStore.catalogCount !== 0 ? catalogFilterData :
                <>
                    Не удалось найти украшения с указанными параметрами.
                    Попробуйте сбросить фильтры.
                </>
        }
    </>
};

export default withStore(CatalogList)
